import React from 'react';
import { defineMessages, injectIntl } from 'gatsby-plugin-react-intl';

import { intlShape } from '@prospectus/common/types/intlShape';

const messages = defineMessages({
  'prospectus.course.snapshot.price.free': {
    id: 'prospectus.course.snapshot.price.free',
    defaultMessage: 'Free',
    description: 'Heading indicating the course is auditable for free',
  },
  'prospectus.course.snapshot.price.upgrade': {
    id: 'prospectus.course.snapshot.price.upgrade',
    defaultMessage: 'Optional upgrade available',
    description: 'This describes that you can upgrade a course if you pay for the verified track.',
  },
});

function UpgradableLanguage({ intl }) {
  return (
    <>
      <div className="h4 mb-0">
        {intl.formatMessage(messages['prospectus.course.snapshot.price.free'])}
      </div>
      <div className="small">
        {intl.formatMessage(messages['prospectus.course.snapshot.price.upgrade'])}
      </div>
    </>
  );
}

UpgradableLanguage.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(UpgradableLanguage);
